import { RichTextField } from '@prismicio/client';
import { prismicToHtmlString } from './prismic-to-html-string';

export const checkForEmptyPrismicHtml = (prismicHtml: RichTextField) => {
  if (!prismicHtml || (prismicHtml.length > 0 && (prismicHtml[0] as { text: string })['text'] === '')) {
    return undefined;
  }
  return prismicToHtmlString(prismicHtml);
};
